import { Result } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

export default function DealerReport() {
  return (
    <Result
      icon={<FileTextOutlined />}
      title="经销商报表"
      subTitle="此功能正在开发中，敬请期待"
    />
  );
}
